import home from './home'
import landing from './landing'
import login from './login'
import main from './main'

export { home, landing, login, main }